module.exports = __webpack_public_path__ + "img/shopping--bag.80b5159b.svg";